exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@keyframes animatedgradient{}.create-parent-communication-wrapper{width:100%;display:block}.create-parent-communication-wrapper .step-by-step-wrapper{padding:24px}", ""]);

